import { inject, Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../Shared/language.service';

// Translates an English key using the shared i18n files (src/Shared/i18n).
// Falls back to the key itself, so English needs no entry.
// {placeholders} are filled from params: {{ 'Hi {name}!' | translate: { name: fullName } }}
// Impure so it re-evaluates when the language changes.
@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {
  private langService = inject(LanguageService);

  transform(key: string, params?: Record<string, unknown>): string {
    const text = this.langService.translate(key);
    if (!params) return text;
    return text.replace(/\{(\w+)\}/g, (match, name) => params[name] != null ? String(params[name]) : match);
  }
}
